module.exports = __webpack_public_path__ + "img/mmi-home-footer-background.d30aa8a3.png";